<template>
  <div id="app" class="slim-scroll">
    <v-app>
      <router-view />
    </v-app>
  </div>
</template>

<script>
export default {
  name: 'App',
};
</script>

<style src="./assets/styles/app.scss" lang="scss"></style>
